import { getEvent } from '@/services/webApi';
import { useQuery } from '@tanstack/react-query';

export default function useEventQuery({ id }: { id: string }) {
  return useQuery({
    queryKey: ['event', id],
    retry: false,
    enabled: Boolean(id),
    queryFn: () => getEvent(id),
    refetchOnMount: true,
    refetchOnReconnect: false,
    refetchOnWindowFocus: false,
    staleTime: 1000 * 60 * 5
  });
}
